import React from "react";
import heroimg from "../../assets/Hero_Banner.png";
import herotop from "../../assets/HeroBannerDesign.svg";
// import design from "../../assets/images/Designs.svg";
import HeroCards from "./HeroCards";
// import SocialBar from "@/layout/Socialbar";

const HeroSection: React.FC = () => {
  return (
    <div className="relative w-full">
      {/* Background Hero Image */}
      <img src={heroimg} alt="Hero Background" className="w-full h-[60vh] md:h-auto object-cover" />

      {/* Hero Top Overlay Design (Responsive positioning) */}
      <img src={herotop} alt="Hero Top Overlay" className="absolute pointer-events-none opacity-25 md:opacity-75 z-0 top-[25%] left-[5%] w-[70%] sm:top-[20%] sm:left-[10%] sm:w-[40%] lg:top-[30%] lg:left-[10%] lg:w-[40%] xl:left-[12%]" />

      {/* Content Overlay */}
      <div className="absolute inset-0 z-10 flex flex-col justify-start p-2 sm:p-4 md:p-6 text-white max-w-[var(--max-width)] mx-auto">
        {/* Contact Info - Top Right */}
        <div className="flex justify-center justify-end text-xs sm:text-sm md:text-base text-gray-200 mb-4 mt-4 md:mt-0">
          <span>+91 9769638029</span>
          <span className="mx-2">|</span>
          <span>info@fdacadvancedsolutions.com</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
          <div className="hidden md:block mt-6 sm:mt-20 md:mt-20 lg:mt-20 xl:mt-60 ml-6 sm:ml-20 md:ml-20 lg:ml-20 xl:ml-60">
            {/* <img className="" src={design} /> */}
          </div>
          {/* Welcome Content Box */}
          <div className="relative mt-6 xs:mt-0 sm:mt-20 md:mt-20 lg:mt-20 ml-auto max-w-full sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-2xl mr-6">
            {/* Bordered Box */}
            <div className="bg-[#0225654d] sm:bg-transparent p-2 xs:p-4 sm:p-5 border border-2 border-[#b0a64c] text-white rounded-md ">
              {/* Welcome to Line */}
              <div className="flex items-center mb-2">
                <span className="text-[#b0a64c] text-xs sm:text-sm md:text-md lg:text-lg xl:text-3xl font-normal whitespace-nowrap bg-[#022565] -mt-[20px] sm:-mt-[41px] p-1 rounded-sm">Welcome to</span>
              </div>

              {/* Title */}
              <h1 className="text-md sm:text-xl md:text-2xl lg:text-4xl xl:text-5xl font-normal mb-1 leading-tight [text-shadow:0px_0px_14px_#000]">FDA Consultancy Pvt. Ltd.</h1>

              {/* Subtitle */}
              <p className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-2xl text-gray-200 leading-tight mb-3 font-light [text-shadow:0px_0px_14px_#000]">Advanced Quality & Regulatory Affairs Solutions at your fingertips</p>
            </div>

            {/* Positioned Button */}
            <button className="absolute sm:-bottom-2 md:-bottom-8 left-4 bg-[#b5ab28] hover:bg-[#c2b24d] text-black text-xs sm:text-sm font-medium px-3 py-1.5 transition duration-200 rounded-bl-md rounded-br-md">
              Know More
            </button>
          </div>
        </div>
      </div>
      {/* <SocialBar /> */}
      <HeroCards />
    </div>
  );
};

export default HeroSection;
